var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating2Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312f2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 1,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9208",
    "data-name": "Group 9208",
    transform: "translate(-3343 -10364)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_440",
    "data-name": "Ellipse 440",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(3343 10364)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_445",
    "data-name": "Ellipse 445",
    cx: 34,
    cy: 34,
    r: 34,
    transform: "translate(3346 10367)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9172",
    "data-name": "Group 9172",
    transform: "translate(3361.494 10388.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8885",
    "data-name": "Path 8885",
    d: "M449.787,22.936a5.992,5.992,0,1,1-5.992-5.992,5.992,5.992,0,0,1,5.992,5.992",
    transform: "translate(-437.803 -16.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8886",
    "data-name": "Path 8886",
    d: "M563.98,22.936a5.992,5.992,0,1,0,5.992-5.992,5.992,5.992,0,0,0-5.992,5.992",
    transform: "translate(-538.951 -16.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8887",
    "data-name": "Path 8887",
    d: "M492.9,126.658a1.692,1.692,0,0,1-1.434-.79,10.96,10.96,0,0,0-8.877-4.708,11.357,11.357,0,0,0-8.891,4.731,1.693,1.693,0,0,1-2.836-1.851,14.728,14.728,0,0,1,11.727-6.266,14.391,14.391,0,0,1,11.745,6.294,1.694,1.694,0,0,1-1.434,2.591",
    transform: "translate(-464.087 -97.772)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating2Dark);
export default __webpack_public_path__ + "static/media/rating_2_dark.d06e5a5b0474832c7494252622d8fa94.svg";
export { ForwardRef as ReactComponent };